import { RouteRecordRaw } from 'vue-router';

export default (): Array<RouteRecordRaw> => {
    return [
        {
            path: '/village/map',
            name: 'village_map',
            component: () => import("./views/map.vue"),
            meta: {
                hasBar: true,
                showMembership: true,
                appContainerClass: 'fullPage',
            }
        },
    ];
};